module.exports = __webpack_public_path__ + "static/media/Loft.4.d625543f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/loft/images/Loft.4.jpg
// module id = 663
// module chunks = 0